import path from "path";

export const acaraSchoolRoutes = [
  {
    path: "/acara-school",
    component: () => import("@/views/ACARASchool/List.vue"),
  },
  {
    path: "/acara-school/create",
    component: () => import("@/views/ACARASchool/Create.vue"),
  },
  {
    path: "/acara-school/update/:acaraSchoolId",
    component: () => import("@/views/ACARASchool/Create.vue"),
  },
];
